const dashboard = {
    title:                      String("Panel principal"),

    // map
    noModulesFound:             String("¡Todavía no has registrado ningúna estación!. Ve al apartado de estaciones para registrar tu primera estación."),
    loadingModules:             String("Espera mientras se carga la información de tus estaciones..."),

    // Map overlay box
    mapOverlayBoxTitle:         String("Selecciona la estación: "),
    mapOverlayBoxTemperature:   String("Temperatura"),
    mapOverlayBoxRelHumidity:   String("Humedad Relativa"),
    mapOverlayBoxRainmeter:     String("Pluviometria"),

    // map info
    noDataForModule:            String("Hoy aún no se ha recibido información de esta estación.")

};

export default dashboard;